import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const enterAgentWhatsAppChannel = (agentId) =>
  http.post(`/channels/whatsapp/connect/agent/${agentId}`);

export const leaveAgentWhatsAppChannel = (agentId) =>
  http.post(`/channels/whatsapp/disconnect/agent/${agentId}`);

export const enterAgentVoiceChannel = ({ agentId, exten }) =>
  http.post(`/channels/voice/connect/agent/${agentId}`, { exten });

export const leaveAgentVoiceChannel = (agentId) =>
  http.post(`/channels/voice/disconnect/agent/${agentId}`);

export const connectChat = (agentId) =>
  http.post(`/channels/chat/connect/agent/${agentId}`).then(handleResponse);

export const disconnectChat = (agentId) =>
  http.post(`/channels/chat/disconnect/agent/${agentId}`).then(handleResponse);

/**
 * getAgentsAvailableOnOrgUnitByChannel
 * Retorna a lista de agentes disponíveis no sistema por canal de atendimento.
 * @param {*} agentId
 * @returns []
 */
export const getAgentsAvailableOnOrgUnitByChannel = (params) =>
  http
    .get(`/agents/${params.channel}/agents-available`, {
      params: { agentId: params.agentId, channel: params.channel },
    })
    .then(handleResponse);
